import style from './policy.module.css';
import { SiteHeader } from '../components/SiteChrome';
import PrivacyPolicyContent from './PrivacyPolicyContent';
import './SupportPage.css';

function Policy() {
    return (
        <>
            <SiteHeader />
            <main className={`${style.policy} legal-modern-page`}>
                <PrivacyPolicyContent />
            </main>
        </>
    );
}

export default Policy;
